import React, { useState } from 'react';
import { Typography } from '@mui/material';

import {
  BackdropForDialog,
  CloseButton,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  SubmitButton,
} from 'components';
import { BuildingForm } from 'forms';

interface BuildingUpdateDialogProps {
  visible?: boolean;
  setVisible?: (value: boolean) => void;
  title?: string;
  submitButtonLabel?: string;
  buildingId: number;
}

export const BuildingUpdateDialog: React.FC<BuildingUpdateDialogProps> = ({
  visible = false,
  setVisible = () => {},
  title = 'Update Building Information',
  submitButtonLabel = 'Update Building',
  buildingId,
}: BuildingUpdateDialogProps) => {
  const [loading_form, setLoadingForm] = useState<boolean>(false);
  const [loading_submit, setLoadingSubmit] = useState<boolean>(false);

  const formRef = React.useRef<any>();

  const onClose = (event: any, reason: string) => {
    if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
      setVisible(false);
      document.body.removeAttribute('style');
    }
  };

  const onSubmit = () => {
    formRef.current.onSubmit();
  };

  return (
    <Dialog open={visible} onClose={onClose}>
      <DialogTitle>
        <Typography variant="h5" component="span">
          {title}
        </Typography>
      </DialogTitle>

      <DialogContent>
        <BuildingForm
          ref={formRef}
          buildingId={buildingId}
          onInit={(loading) => setLoadingForm(loading)}
          onSubmitting={(loading) => setLoadingSubmit(loading)}
          next={() => {
            onClose(null, 'anyway');
          }}
        />
      </DialogContent>

      <DialogActions>
        <SubmitButton loading={loading_submit} label={submitButtonLabel} onClick={onSubmit} />
      </DialogActions>

      <CloseButton onClick={() => onClose(null, 'anyway')} sx={{ zIndex: (theme) => theme.zIndex.modal + 1 }} />

      <BackdropForDialog loading={loading_form} />
    </Dialog>
  );
};
